import { ROUTES } from '~/data/routes';
import { useMemo } from 'react';
import { useRouter } from 'next/router';

export const useGetNewCarRoute = (isLease?: boolean) => {
  const { asPath } = useRouter();

  return useMemo(() => {
    const isLeasePath = asPath.startsWith('/private-leasing');

    // If selectedGroup is set, not LOAN_CAR or NEW_CAR, and the path starts with '/private-leasing'
    if (isLeasePath || isLease) {
      return ROUTES.PRIVATE_LEASING;
    }

    return ROUTES.CAR_PAGE;
  }, [asPath, isLease]);
};
